module.exports = __webpack_public_path__ + "img/maupassant.493bd8bc.jpg";